import { OrderedMap } from 'immutable';

import { EMPTY_MAP } from 'app/app.constants';
import wellboreFileMapper from 'features/wells/wellboreFiles.mappers';
import { WELLBORE_FILE_ACTIONS } from 'features/wells/wellboreFiles.constants';

const initialState = EMPTY_MAP;

const wellboreFileReducer = (state = initialState, action) => {
  const { type, error, payload } = action;

  switch (type) {
    case WELLBORE_FILE_ACTIONS.RECEIVE_WELLBORE_FILE: {
      if (error) return state;

      const { payload } = action;

      return state.set(
        payload.fileId.toString(),
        wellboreFileMapper.WellboreFile.from(payload),
      );
    }

    case WELLBORE_FILE_ACTIONS.DELETE_WELLBORE_FILE: {
      if (error) return state;

      const { wellboreFileId } = action;

      return state.delete(wellboreFileId.toString());
    }

    case WELLBORE_FILE_ACTIONS.RECEIVE_WELLBORE_FILES: {
      if (error) return state;

      return OrderedMap(
        payload.map((wellboreFile) => [
          wellboreFile.fileId === 0
            ? wellboreFile.externalId
            : wellboreFile.fileId,
          wellboreFileMapper.WellboreFile.from(wellboreFile),
        ]),
      );
    }

    case WELLBORE_FILE_ACTIONS.UPDATE_WELLBORE_FILE: {
      const updatedFile = payload.payload;
      let stateJSON = state.toJS();

      const key =
        updatedFile?.fileId != null
          ? updatedFile.fileId.toString()
          : updatedFile.externalId;

      const existing = stateJSON[key];

      if (!existing) return state;

      const merged = {
        ...existing,
        ...updatedFile,
      };

      stateJSON[key] = merged;

      return OrderedMap(
        Object.entries(stateJSON).map(([key, value]) => [
          key,
          wellboreFileMapper.WellboreFile.from(value),
        ]),
      );
    }

    default:
      return state;
  }
};

export default wellboreFileReducer;
